import { useState, useCallback, useMemo } from "react";
import { translations, type Lang } from "@/i18n/translations";
import { IS_DEMO, demoTranslations } from "@/lib/demo";

const detectLang = (): Lang => {
  const nav = navigator.language || "en";
  return nav.startsWith("es") ? "es" : "en";
};

export const useLanguage = () => {
  const [lang, setLang] = useState<Lang>(detectLang);

  const toggleLang = useCallback(() => {
    setLang((prev) => (prev === "es" ? "en" : "es"));
  }, []);

  const t = useMemo(() => (IS_DEMO ? demoTranslations(translations[lang]) : translations[lang]), [lang]);

  return { lang, toggleLang, t };
};
